/* eslint-disable no-restricted-imports */
import { ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        "text-inherit",

        "text-h1",
        "text-h2",
        "text-h3",
        "text-h4",
        "text-body1",
        "text-body2",
        "text-caption",
      ],
    },
  },
})

export const cn = (...inputs: ClassValue[]) => {
  return customTwMerge(clsx(inputs))
}

type Color =
  // Base colors
  | "transparent"
  | "current"
  | "white"
  | "black"
  // Brand Primary
  | "brand-primary-100"
  | "brand-primary-200"
  | "brand-primary-300"
  | "brand-primary-400"
  | "brand-primary-500"
  | "brand-primary-600"
  | "brand-primary-700"
  | "brand-primary-900"
  // Brand Secondary
  | "brand-secondary-100"
  | "brand-secondary-200"
  | "brand-secondary-300"
  | "brand-secondary-400"
  | "brand-secondary-500"
  | "brand-secondary-700"
  | "brand-secondary-900"
  // Accent 1
  | "accent-1-100"
  | "accent-1-200"
  | "accent-1-300"
  | "accent-1-400"
  | "accent-1-500"
  | "accent-1-600"
  | "accent-1-700"
  | "accent-1-800"
  | "accent-1-900"
  // Accent 2
  | "accent-2-100"
  | "accent-2-200"
  | "accent-2-300"
  | "accent-2-400"
  | "accent-2-500"
  | "accent-2-600"
  | "accent-2-700"
  | "accent-2-800"
  | "accent-2-900"
  // Accent 3
  | "accent-3-100"
  | "accent-3-200"
  | "accent-3-300"
  | "accent-3-400"
  | "accent-3-500"
  | "accent-3-600"
  | "accent-3-700"
  | "accent-3-800"
  | "accent-3-900"
  // Data Viz 1
  | "data-viz-1-1"
  | "data-viz-1-2"
  | "data-viz-1-3"
  | "data-viz-1-4"
  // Data Viz 2
  | "data-viz-2-1"
  | "data-viz-2-2"
  | "data-viz-2-3"
  | "data-viz-2-4"
  // Data Viz 3
  | "data-viz-3-1"
  | "data-viz-3-2"
  | "data-viz-3-3"
  | "data-viz-3-4"
  // Data Viz 4
  | "data-viz-4-1"
  | "data-viz-4-2"
  | "data-viz-4-3"
  | "data-viz-4-4"
  // Error
  | "error-100"
  | "error-200"
  | "error-300"
  | "error-400"
  | "error-500"
  | "error-600"
  | "error-700"
  | "error-800"
  | "error-900"
  // Success
  | "success-100"
  | "success-200"
  | "success-300"
  | "success-400"
  | "success-500"
  | "success-600"
  | "success-700"
  | "success-800"
  | "success-900"
  // Grey
  | "grey-100"
  | "grey-200"
  | "grey-300"
  | "grey-400"
  | "grey-500"
  | "grey-700"
  | "grey-800"
  | "grey-900"
  // Haze
  | "haze-100"
  | "haze-200"
  | "haze-300"
  | "haze-400"
  | "haze-500"
  | "haze-700"
  | "haze-900"
  // Sand
  | "sand-100"
  | "sand-200"
  | "sand-300"
  | "sand-500"
  | "sand-700"
  | "sand-900"

export const getThemeColor = (color: Color) => {
  const varName = `--color-${color}`
  const value = getComputedStyle(document.body).getPropertyValue(varName)
  return value
}

export const getCssVar = (key: string) => {
  const varName = `--${key}`
  const value = getComputedStyle(document.body).getPropertyValue(varName)
  return value
}
